// extracted by mini-css-extract-plugin
module.exports = {"container":"KTtxFDM8dI-mdYEKDcPz3","requiredLabel":"SYrSR6hs3nBJidDbdslNZ","items":"VRqaTAvFBiVPHsKjOM6nz"};